// extracted by mini-css-extract-plugin
export var offer = "style-module--offer--5231a";
export var offer__block = "style-module--offer__block--09cf9";
export var offer__blocks = "style-module--offer__blocks--e2784";